
// 
// TODO - need to keep a list of version updates ...
// TODO - make use of cache to allow storing and retrieving local values
// TODO - adjust API to set empty values to proper types / formatting
//

import Http from "@/services/Http";
import Events from "@/services/Emitter";
import Helper from "@/services/Helper";
import Cache from "@/services/Cache";
import { useAppStore } from "@/stores/AppStore";

const ns = {};

const startSpin = (bg) =>
{
    if (!bg)
    {
        Events.emit("loading", true);
    }
};

const stopSpin = (bg) =>
{
    if (!bg)
    {
        Events.emit("loading", false);
    }
}

ns.login = async (email, password) =>
{
    Events.emit("loading", true);

    let res = await Http.post("/auth/login?v=1", {
        Email: email,
        Password: password
    });

    Events.emit("loading", false);
    return res;
};

ns.checkForNewerVersion = async () =>
{
    let html = await Http.get("https://radarapp.7thleveltech.com/client/index.html?=1", null, true);

    console.debug("checking new version", html);

    // alert(html);
};

// CORS error ... ?
// ns.checkForNewerVersion();

ns.keepAlive = async () =>
{
    let bearer = Cache.get("bearer");
    if (bearer) 
    {
        let last = Cache.get("alive") || new Date();
        let now = new Date();
        Cache.set("alive", last);
        let diffSeconds = (now.getTime() - last.getTime()) / 1000;
        console.debug("keep alive client", diffSeconds);
        
        if (30 < diffSeconds) 
        {
            console.debug("keep alive server", diffSeconds);
            let rs = await Http.post("/auth/keepalive?v=1");
            if (rs.Token) 
            {
                let store = useAppStore();
                store.setAccount(rs);
                Cache.set("alive", new Date()); //< store now ...
            }
        }
    }

    // run every minute ...
    setTimeout(() => {
        ns.keepAlive();
    }, 1000 * 20);
}

ns.keepAlive();


//#region Files

ns.loadRequestFiles = async (requestId, bg) =>
{
    if (!requestId)
    {
        return [];
    }

    startSpin(bg);
    let res = await Http.get("/Data/RequestList/" + requestId + "?v=1");
    stopSpin(bg);
    return res;
};

ns.saveFile = async (data, bg) =>
{
    startSpin(bg);
    let res = await Http.upload("/Data/Upload?v=1", data);
    stopSpin(bg);
    return res;
};

ns.deleteFile = async(id, bg) =>
{
    if (!id)
    {
        return null;
    }

    startSpin(bg);
    let res = await Http.post("/Data/Delete/" + id + "?v=1");
    stopSpin(bg);
    return res;
};

//#endregion


//#region ClockPause

ns.loadPauses = async (clockId, bg) =>
{
    if (!clockId)
    {
        return [];
    }

    startSpin(bg);
    let res = await Http.get("/ClockPause/List/" + clockId + "?v=1");
    stopSpin(bg);
    return res;
};

ns.loadLastPause = async (clockId, bg) =>
{

    if (!clockId)
    {
        return null;
    }

    startSpin(bg);
    let res = await Http.get("/ClockPause/Latest/" + clockId + "?v=1");
    stopSpin(bg);
    return res;
};

ns.loadPause = async (pauseId, bg) =>
{
    if (!pauseId)
    {
        return null;
    }

    startSpin(bg);
    let res = await Http.get("/ClockPause/Details/" + pauseId + "?v=1");
    stopSpin(bg);
    return res;
};

ns.savePause = async (model, bg) =>
{
    startSpin(bg);
    let res = await Http.post("/ClockPause/Save?v=1", model);
    stopSpin(bg);
    return res;
};

ns.deletePause = async (pauseId, bg) =>
{
    if (!pauseId)
    {
        return null;
    }

    startSpin(bg);
    let res = await Http.post("/ClockPause/Delete/" + pauseId + "?v=1");
    stopSpin(bg);
    return res;
};

//#endregion

//#region Staff

ns.loadStaff = async (filter, bg) =>
{
    startSpin(bg);
    let res = await Http.get("/staff/list?v=1", filter);
    stopSpin(bg);
    return res;
};

ns.loadStaffById = async (id, bg) =>
{
    startSpin(bg);
    let res = await Http.get("/staff/details/" + id + "?v=1");
    
    stopSpin(bg);

    return res;
};

ns.saveStaff = async (staff, bg) =>
{
    startSpin(bg);

    // this returns the task ... should we update to only return the clock?
    let res = await Http.post("/staff/save?v=1", staff);
    
    stopSpin(bg);

    return res;
};

ns.deleteStaff = async (id, bg) =>
{
    startSpin(bg);
    
    // this returns the task ... should we update to only return the clock?
    let res = await Http.post("/staff/delete/" + id + "?v=1");
    
    stopSpin(bg);

    return res;
};



//#region Projects

ns.getProjectStatus = async (bg) =>
{
    startSpin(bg);
    
    let res = await Http.get("/project/status?v=1");
    
    stopSpin(bg);

    return res;
};


//#region Clocks
ns.loadClocks = async (bg) =>
{
    startSpin(bg);
    
    let res = await Http.get("/TaskClock/List?v=1");
    
    stopSpin(bg);

    return res;
};

// loads the task with the clock attached ...
ns.loadClock = async(id, bg) =>
{
    if (!id)
    {
        return null;
    }

    startSpin(bg);
    
    let res = await Http.get("/TaskClock/Details/" + id + "?v=1");
    
    stopSpin(bg);

    return res;
};

// takes the clock ...
ns.saveClock = async (clock, bg) =>
{
    startSpin(bg);

    // this returns the task ... should we update to only return the clock?
    let res = await Http.post("/TaskClock/Save?v=1", clock);
    
    stopSpin(bg);

    return res;
};

//#endregion

//#region Techs
ns.loadTechs = async (bg) =>
{
    startSpin(bg);

    // LOAD ALL FOR NOW ...
    let rs = await Http.get("/user/list?page=0&size=999999&v=1");

    // fix selects, numbers, etc. 

    stopSpin(bg);

    return rs;
};

ns.loadTech = async (id, bg) =>
{
    startSpin(bg);

    let rs = await Http.get("/user/details/" + id + "?v=1");
    
    // fix selects, numbers, etc.
    rs.Email = rs.Credential.Key;

    stopSpin(bg);

    return rs;
};

ns.saveTech = async (tech, bg) =>
{
    startSpin(bg);

    let rs = await Http.post("/user/save?v=1", tech);
    
    stopSpin(bg);

    return rs;  
};
//#endregion

//#region Clients
ns.loadClients = async (bg) =>
{
    startSpin(bg);

    // LOAD ALL FOR NOW ...
    let rs = await Http.get("/company/list?page=0&size=999999&v=1");
    
    stopSpin(bg);

    return rs;
};

ns.loadClient = async (id, bg) => 
{
    startSpin(bg);

    let rs = await Http.get("/company/details/" + id + "?v=1");
    
    stopSpin(bg);

    return rs;
};

ns.loadClientByCustomerNumber = async(cust, bg) =>
{
    startSpin(bg);

    let rs = await Http.get("/company/list?v=1", {
        CustomerNumber: cust
    });
    
    stopSpin(bg);
    

    return rs && rs.length && rs[0];
}

ns.saveClient = async (client, bg) => 
{
    startSpin(bg);

    let rs = await Http.post("/company/save?v=1", client);
    
    stopSpin(bg);

    return rs;
}
//#endregion

//#region Job
ns.loadJobs = async (filter, bg) =>
{
    startSpin(bg);
    let rs = await Http.get("/job/list?v=1", filter);

    // sort the jobs by status here for now ...
    rs.sort((a, b) => 
    {
        return a.RequestStatus - b.RequestStatus;
    });

    stopSpin(bg);
    return rs;
};

ns.loadJob = async (id, bg) =>
{

    if (!id)
    {
        return null;
    }

    startSpin(bg);
    let rs = await Http.get("/job/details/" + id + "?v=1");

    // fix all job fields
    // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

    if (rs.DueDate)
    {
        rs.DueDate = new Date(rs.DueDate.split("T")[0]);
        rs.DueDate = Helper.dateToInput(rs.DueDate, Helper.DateFormat_Date);
    }

    if (rs.Priority)
    {
        rs.Priority = Number(rs.Priority);
    } 
    
    else 
    {
        rs.Priority = "";
    }

    if (rs.RequestStatus)
    {
        rs.RequestStatus = Number(rs.RequestStatus);
    } 
    
    else 
    {
        rs.RequestStatus = "";
    }

    stopSpin(bg);
    return rs;
};

ns.loadJobStatus = async (bg) =>
{
    startSpin(bg);
    let rs = await Http.get("/JobStatus/List?v=1");
    stopSpin(bg);
    return rs;
}

ns.saveJob = async (job, bg) =>
{
    startSpin(bg);
    
    let rs = await Http.post("/job/save?v=1", job);
    
    stopSpin(bg);
    
    return rs;
};
//#endregion

//#region Time
const fixTime = (rs) =>
{
    rs.ClientId = rs.Request?.Customer;

    if (rs.TaskLocation)
    {
        rs.TaskLocation = Number(rs.TaskLocation);
    }

    else
    {
        rs.TaskLocation = "";
    }

    if (rs.Status)
    {
        rs.Status = Number(rs.Status);
    }

    if (rs.CompleteByDate)
    {
        rs.CompleteByDate = new Date(rs.CompleteByDate.split("T")[0] + " 00:00:00");
        rs.CompleteByDate = Helper.dateToInput(rs.CompleteByDate, Helper.DateFormat_Date);
    }

    if (rs.WorkCompleteDate)
    {
        rs.WorkCompleteDate = new Date(rs.WorkCompleteDate.split("T")[0] + " 00:00:00");
        rs.WorkCompleteDate = Helper.dateToInput(rs.WorkCompleteDate, Helper.DateFormat_Date);
    }

    return rs;
};

ns.loadTimeStatus = async (bg) =>
{
    startSpin(bg);
    let rs = await Http.get("/TimeStatus/List?v=1") || [];
    stopSpin(bg);
    return rs;
};

ns.loadTaskStatus = ns.loadTimeStatus;

ns.loadTimes = async (filter) =>
{
    Events.emit("loading", 1);
    let rs = await Http.get("/time/list?v=1", filter) || [];
    for (let i = 0; i < rs.length; i++)
    {
        rs[i] = fixTime(rs[i]);
    }
    Events.emit("loading", 0);
    return rs;
};

ns.loadTime = async (id) =>
{
    Events.emit("loading", 1);
    let rs = await Http.get("/time/details/" + id + "?v=1");
    rs = fixTime(rs);
    Events.emit("loading", 0);
    return rs;
};

ns.saveTime = async (time) =>
{
    Events.emit("loading", 1);
    let rs = await Http.post("/time/save?v=1", time);
    Events.emit("loading", 0);
    return rs;
};
//#endregion

//#region Mileage
ns.loadMileages = async (filter) =>
{
    Events.emit("loading", 1);
    let rs = await Http.get("/mileage/list?v=1", filter);
    Events.emit("loading", 0);
    return rs;
};

ns.loadMileage = async (id) =>
{
    Events.emit("loading", 1);
    let rs = await Http.get("/mileage/details/" + id + "?v=1");
    Events.emit("loading", 0);
    return rs;
};

ns.saveMileage = async (mileage) =>
{
    Events.emit("loading", 1);
    let rs = await Http.post("/mileage/save?v=1", mileage);
    Events.emit("loading", 0);
    return rs;
};
//#endregion

//#region Parts
ns.loadParts = async (filter) =>
{
    Events.emit("loading", 1);
    let rs = await Http.get("/part/list?v=1", filter);
    Events.emit("loading", 0);
    return rs;
};

ns.loadPart = async (id) =>
{
    Events.emit("loading", 1);
    let rs = await Http.get("/part/details/" + id + "?v=1");
    Events.emit("loading", 0);
    return rs;
}

ns.savePart = async (part) =>
{
    Events.emit("loading", 1);
    let rs = await Http.post("/part/save?v=1", part);
    Events.emit("loading", 0);
    return rs;
};

ns.searchParts = async (searchTerm, bg) =>
{
    if (!searchTerm)
    {
        return [];
    }

    startSpin(bg);
    let res = await Http.get("/Part/Search?v=1", { searchTerm });
    stopSpin(bg);
    return res;
};

ns.loadPartFiles = async (partId, bg) =>
{
    if (!partId)
    {
        return [];
    }

    startSpin(bg);
    let res = await Http.get("/Data/PartList/" + partId + "?v=1");
    stopSpin(bg);
    return res;
};

//#endregion

//#region Expenses
ns.loadExpenses = async (filter) =>
{
    Events.emit("loading", 1);
    let rs = await Http.get("/expense/list?v=1", filter);
    Events.emit("loading", 0);
    return rs;
};

ns.loadExpense = async (id, bg) =>
{
    startSpin(bg);

    let rs = await Http.get("/expense/details/" + id + "?v=1");

    if (rs) 
    {
        rs.ClientId = rs.Request?.Customer;

        if (rs.ExpenseDate)
        {
            rs.ExpenseDate = new Date(rs.ExpenseDate.split("T")[0] + " 00:00:00");
            rs.ExpenseDate = Helper.dateToInput(rs.ExpenseDate, Helper.DateFormat_Date);
        }
    }
    
    stopSpin(bg);
    
    return rs;
};

ns.saveExpense = async (expense, bg) =>
{
    let pay = Helper.copy(expense);

    startSpin(bg);

    if (pay.ExpenseDate)
    {
        // store in local time 
        pay.ExpenseDate = pay.ExpenseDate + " 00:00:00";
    }

    let rs = await Http.post("/expense/save?v=1", pay);
    
    stopSpin(bg);

    return rs;
};
//#endregion

//#region Notes
const fixNote = (rs) =>
{
    if (rs.DateTaken)
    {
        rs.DateTaken = Helper.dateToInput(Helper.dateFromString(rs.DateTaken), Helper.DateFormat_DateTime);
    }

    return rs;
};

ns.loadNotes = async (filter, bg) =>
{
    /* alert("here"); */
    startSpin(bg);

    let rs = await Http.get("/TaskNote/List?v=1", filter);
    // Helper.
    stopSpin(bg);

    return rs;
};

ns.loadNote = async (id, bg) =>
{
    if (!id)
    {
        return null;
    }

    startSpin(bg);

    let rs = await Http.get("/TaskNote/Details/" + id + "?v=1") || {};

    // fix selects, dates, etc ...
    rs = fixNote(rs);

    stopSpin(bg);

    return rs;
};

ns.saveNote = async (note) =>
{
    Events.emit("loading", 1);
    let rs = await Http.post("/TaskNote/Save?v=1", note);
    Events.emit("loading", 0);
    return rs;
};
//#endregion

export default ns;